import { ENV_NAME } from '../constants/environment'

export const CHECK_CNPJ = '/client/ecommerce-agent/cart/unavailable_products'

// Lista os produtos da home
export const PRODUCTS_LIST =
    '/agent/products-agent/flags/products?origin=:origin'

// Verifica CNPJ / Cria o "Carrinho"
export const CREATE_CART = '/client/ecommerce-agent/cart/create'

// Atualização do Carrinho
export const UPDATE_CART = '/api/sales/shopping-cart'

// Obtenção de Taxas
export const GET_FEE = '/agent/products-agent/proposal/:cartId?origin=:origin'

// Obtenção do Endereço por CEP
export const GET_ADDRESS_BY_POSTAL_CODE = '/api/places/address'

// Inicia geração de contrato
export const contractManagement =
    '/agent/products-agent/carts/:cartId/contracts'

// Checa status da geração de contrato
export const getContractManagement = '/client/ecommerce-agent/contracts/'

// Abre/Baixa boleto da proposta
export const proposalPDF = '/agent/products-agent/report/:id'

// Obter recovery do carrinho
export const RECOVERY_CART = '/api/sales/shopping-cart/:cartId/recovery'

// Obtem carrinho do ecommerce
export const GET_CART = '/api/sales/shopping-cart/:cartId'

// Pega a data atual do servidor
export const AGENT_DATE = '/client/ecommerce-agent/time'

// Obter lista de banners para o carousel da home
export const GET_HOME_BANNERS = `https://www.alelo.com.br/content/dam/ecommerce/${ENV_NAME}/banners/info.jsonp`

// Obter dados da promoção para a tela de detalhes da home
export const GET_HOME_OFFER_DETAIL = `https://www.alelo.com.br/content/dam/ecommerce/${ENV_NAME}/banners/:path/imagens/info.jsonp`

// Obter dados da pagina interna de produtos WCM
export const GET_INTERNAL_PRODUCT = `https://www.alelo.com.br/content/dam/ecommerce/${ENV_NAME}/detalhesprodutos/:product/info.jsonp`

// Cria produto no carrinho para lead de cross sell
export const CREATE_PRODUCT = '/api/sales/shopping-cart/:cartId/product'
